/* istanbul ignore file */
import React from 'react';
import EqCondition from './condition/EqCondition';
import { Dropdown, DefaultDropdownProps } from 'framework/form';

const DEFAULT_OPTIONS = [
  {
    label: 'Yes',
    value: 'YES',
  },
  {
    label: 'No',
    value: 'NO',
  },
];

const BooleanFilter = (props: Omit<DefaultDropdownProps, 'value'>) => {
  return (
    <EqCondition {...props}>
      <Dropdown options={DEFAULT_OPTIONS} placeholder="Select" {...props} />
    </EqCondition>
  );
};

export default BooleanFilter;
